<template>
  <header @click="toggleComponent()">
    <h2>
      <div class="flex flex-col items-center md:items-baseline">
        <div class="w-full uppercase text-xs" v-if="superHeadline">{{ superHeadline }}</div>
        <div class="w-full text-md font-bold leading-none pt-1" v-if="titleObj">{{ titleObj.title }}</div>
      </div>
      <svg class="w-5 h-5 ml-auto">
        <use v-if="!componentActive" xlink:href="#plus-circle"/>
        <use v-if="componentActive" xlink:href="#minus-circle"/>
      </svg>
    </h2>
    <slot name="notification"></slot>
  </header>
</template>

<script>

export default {
  name: 'Header',
  props: {
    titleObj: {
      type: Object,
      required: true
    },
    componentActive: {
      type: Boolean,
      required: true
    },
    superHeadline: {
      type: String,
      required: false
    }
  },
  methods: {
    toggleComponent () {
      this.log = 'Header: toggleComponent - invoked; this.componentActive = ' + this.componentActive + '<br>'
      this.$emit('toggleComponentStatus', this.componentActive)
    }
  },
  watch: {
    componentActive: function (val) {
      this.log = 'Header: watch - componentActive: val = ' + val + '<br>'
    }
  }
}
</script>

<style lang="postcss" scoped>
h2 {
  @apply flex items-center justify-between text-xl text-pink-800
}
</style>
